export const CACHE_KEY_LIST_CLIENTS_DIRECTORY = 'clients-directory';
export const CACHE_KEY_CLIENT_DIRECTORY = 'clients-directory-one';
export const ROUTE_PATH_CLIENTS_DIRECTORY = '/clients/directory-list';
export const TRANSLATION_PREFIX_CLIENTS_DIRECTORY = 'clients';

